import loadable from '@loadable/component';

export const EmbedSearchWidgetViewJobPageLoadable = loadable(
  () => import('./EmbedSearchWidgetViewJobPage'),
  { resolveComponent: (module) => module.EmbedSearchWidgetViewJobPage },
);
